import { RawApplicationContext } from '../../app';
import { ApplicationContextCustom, IApplicationContext } from '../../../shared/types/applicationContext';

export function createContext(rawApplicationContext: RawApplicationContext): IApplicationContext {
  return {
    ...rawApplicationContext,
    custom: rawApplicationContext.config.getStrict<ApplicationContextCustom>('applicationContext.custom'),
  };
}
